import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../css/pages/settings.css';

import useAuth from "../hooks/useAuth";
import { getExtractionEnabled, setExtractionEnabled } from "../api/documentAPI";
import { setUserLanguage } from "../api/authenticateAPIs";
import { applyLang, saveLang } from "../services/language";

const Settings = () => {

    const navigate = useNavigate();
    const { auth } = useAuth();
    const isAdmin = Number(auth?.uri) === 1;   // rola ADMIN (roleId === 1)
    const [t, i18n] = useTranslation('global');
    const [extractionEnabled, setExtractionEnabledState] = useState(true);
    const [diskPause, setDiskPause] = useState(null);   // { free, reserve } keď strážca disku pozastavil spracovanie

    // Globálny prepínač extrakcie (app_settings.extraction_enabled) – načítaj len pre admina.
    useEffect(() => {
        if (isAdmin) {
            getExtractionEnabled()
                .then((d) => {
                    setExtractionEnabledState(!!d?.Enabled);
                    setDiskPause(d?.Paused && d?.PauseReason === 'DISK_LOW'
                        ? { free: d.DiskFreeGB, reserve: d.DiskReserveGB } : null);
                })
                .catch(() => {});
        }
    }, [isAdmin]);

    const handleExtractionToggle = async () => {
        const next = !extractionEnabled;
        setExtractionEnabledState(next);          // optimisticky
        try {
            await setExtractionEnabled(next);
        } catch (e) {
            setExtractionEnabledState(!next);      // pri chybe vráť späť
        }
    };

    // Voľba sa pamätá v prehliadači (1 rok) aj v účte — po zmazaní cookies (Edge) sa obnoví pri prihlásení
    const changeLanguage = (e) => {
        const lang = applyLang(e.target.value);
        saveLang(lang);
        setUserLanguage(lang).catch((err) => console.log('Jazyk sa nepodarilo uložiť do účtu', err));
    };

    const handleGoBack = () => {
        navigate('/');
    };

    return (
        <div className='settings-wrap'>
            <button className="return-button return-button-top" onClick={handleGoBack}>
                <span className="material-symbols-outlined">arrow_back</span>{t('return')}
            </button>
            <div className="header-title"><h1>{t('settings')}</h1></div>
            <div className='main-wrapper'>
                <div className="language-panel">
                    <div className="input-line">
                        <label htmlFor="lastName">{t('language')}</label>
                        <select
                            className="language-select"
                            name="languages_select"
                            id="languagesSelect"
                            onChange={changeLanguage}
                            value={i18n.language}
                        >
                            <option value="cz">Čeština</option>
                            <option value="sk">Slovenčina</option>
                            <option value="en">English</option>
                        </select>
                    </div>
                </div>

                {isAdmin && (
                    <div className="extraction-panel">
                        <div className="input-line ad-group-toggle-row">
                            <label htmlFor="extractionToggle">{t('extractionEnabled')}</label>
                            <label className="switch" htmlFor="extractionToggle">
                                <input
                                    type="checkbox"
                                    id="extractionToggle"
                                    checked={extractionEnabled}
                                    onChange={handleExtractionToggle}
                                />
                                <span className="slider"></span>
                            </label>
                        </div>
                        <span className="team-ad-group-note">{t('extractionEnabledHint')}</span>
                        {diskPause && (
                            <span className="extraction-disk-warning">
                                {t('extractionPausedDiskLow', { free: diskPause.free, reserve: diskPause.reserve })}
                            </span>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default Settings;
